/* ============================================================================
 * PRODUCT RACKET FORM SUBMISSION (js__product-racket-submit.js)
 * ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  /* ============================================================================
  * DEMO RACKETS
  * ============================================================================ */
  const modalDemo = document.getElementById('demoPopup');
  if (modalDemo) {
    const demos = modalDemo.querySelectorAll('.demo-racket input');
    const submitBtnDemo = modalDemo.querySelector('button');
  
    if (submitBtnDemo) {
      submitBtnDemo.disabled = true;
    
      modalDemo.addEventListener('hidden.bs.modal', () => {
        demos.forEach(demo => demo.checked = false);
        submitBtnDemo.disabled = true;
      });
    
      demos.forEach(demo => {
        demo.addEventListener('click', () => {
          submitBtnDemo.disabled = !Array.from(demos).some(d => d.checked);
        });
      });
    }
  }

});

// --- Racket/Demo/Stringing Cart Function ---
window.onSubmitCartForm = async (form, event) => {
  event.preventDefault();
  
  // 1. Cache form elements
  const btnTxt = form.querySelector('.btn-cart span:first-child');
  const input = form.querySelector('input[name="quantity"]');
  const quantity = form.querySelector('.cart-quantity');
  const btnMinus = form.querySelector('.btn-minus');
  const btnPlus = form.querySelector('.btn-plus');
  const submitButton = btnTxt ? btnTxt.closest('button') : null;

  // 2. Set loading state
  btnTxt.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
  if (submitButton) submitButton.disabled = true;

  // 3. Prepare fetch variables
  let fetchBody;
  let fetchHeaders = {};
  let isJson = false;

  const demoRacketCheck = form.querySelector('.demo-racket input:checked');

  // 4. Build the fetchBody based on logic
  if (demoRacketCheck) {
    // --- DEMO RACKET LOGIC ---
    isJson = true;
    const data = {
      items: [
        {
          quantity: 1,
          id: demoRacketCheck.value
        }
      ]
    };
    fetchBody = JSON.stringify(data);

  } else {
    // --- DEFAULT RACKET LOGIC ---
    disableBtns(form); // Disable +/-
    isJson = false;
    fetchBody = new FormData(form);
  }

  // 5. Perform the single fetch call
  if (isJson) {
    fetchHeaders["Content-Type"] = "application/json";
  }
  
  const response = await fetch('/cart/add.js', { 
    method: 'POST', 
    body: fetchBody,
    headers: fetchHeaders
  });

  // 6. Handle success and reset form
  btnTxt.innerHTML = `${window.theme.product.addToCart}`;
  window.refreshCartContents(response);
  bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();

  if (submitButton) submitButton.disabled = false;

  // Reset quantity inputs (if they exist)
  if (input && quantity && btnMinus && btnPlus) {
    input.value = 1;
    quantity.textContent = 1;
    
    // Manually set the state just like onChangeProductOption does
    btnMinus.disabled = true; 

    // Re-check the max quantity from the button's data attribute
    let cleanMax = parseInt(btnPlus.dataset.max);
    if (isNaN(cleanMax)) {
        // If max was "null" or "undefined", treat as 0
        cleanMax = 0;
    }
    
    btnPlus.disabled = (1 >= cleanMax);
    
    // We DO NOT call enableBtns().
  }
}